import { HTMLAttributeAnchorTarget, PropsWithChildren } from "react";
import { To } from "react-router";
import { IconTypeEnum } from "@components/Icon/utils/types";
import { FeedTag } from "@routes/Keyword/utils/types";
import { CommonClassNameAndTestId } from "@typings/Common";

export enum ButtonSize {
  small = "sm",
  medium = "md",
  large = "lg",
}

export enum ActionType {
  linkButton = "linkButton",
  shareButton = "shareButton",
  actionButton = "actionButton",
  tabButton = "tabButton",
}

export enum KeywordButtonType {
  default = "default",
  version2 = "version2",
  version3 = "version3",
}

export enum SocialMediaType {
  facebook = "facebook",
  telegram = "telegram",
  email = "email",
  linkedin = "linkedin",
  twitter = "twitter",
  whatsapp = "whatsapp",
  instagram = "instagram",
}

export type ButtonProps = {
  /**  The type of social media to render */
  whichSocialMedia?: SocialMediaType;
  /** Article title */
  title?: string;
  /**  The URL to share */
  shareUrl?: string;
  /**  The type of icon to display*/
  icon?: IconTypeEnum;
  /**  Text to display in the button */
  text?: string;
  /**  The type of action to perform */
  actionType?: ActionType;
  /** Image alt text */
  imgAlt?: string;
  /** Size of the button */
  buttonSize?: ButtonSize;
  /** Size of the icon */
  iconSize?: number;
  /** on click function */
  onClick?: (e: React.SyntheticEvent) => void;
  /** Extra function to call on click */
  callback?: () => void;
} & PropsWithChildren &
  CommonClassNameAndTestId;

export type KeywordsButtonDefaultProps = {
  /** function to handle click */
  handleClick?: () => void;
  /** indicator if is loading for an event */
  isLoading: boolean;
  /** classs for icon */
  iconClassName?: string;
  /** indicator is the keyword is followed */
  isTagFollowed: boolean;
} & CommonClassNameAndTestId;

export type KeywordWithFollowTextProps = KeywordsButtonDefaultProps;

export type KeywordVersion3Props = {
  /** function to handle click */
  handleClick?: () => void;
  /** keyword tag object */
  keyword?: FeedTag;
  /** indicator is the keyword is followed */
  isTagFollowed: boolean;
  /** indicator if it is a anomoyous user */
  isAnonymousUser?: boolean;
} & CommonClassNameAndTestId;

export type KeywordsButtonProps = {
  /**  The type of keyword button to render */
  keywordButtonType: KeywordButtonType;
  /** Keyword Tag Object */
  keyword?: FeedTag;
} & KeywordsButtonDefaultProps &
  CommonClassNameAndTestId;

export type ButtonFactoryProps = {
  /** This is the classname of the component. */
  className?: string;
  /** The type of button, based on this it will decide how the styling will be. */
  buttonType: ButtonType;
  //** The button text. */
  text?: string;
  /** The link to, used in ButtonLink. */
  link?: To;
  /** The onclick event to call after clicking the button, can be used in analytics. */
  onClick?: () => void;
  /** The icon to be displayed, button will become square if children is undefined. */
  icon?: React.ReactElement;
  /** This sets where to place the icon. */
  iconPosition?: "left" | "right";
  /** The option to change the style to primary / secondary button, mainly used by Link Button */
  mask?: ButtonType.Primary | ButtonType.Secondary;
  /** The children to be rendered inside the button */
  children?: React.ReactNode;
  /** The target attribute specifies where to open the linked document, only used when buttonType is Link */
  target?: HTMLAttributeAnchorTarget;
  /** Optional test Id */
  testId?: string;
  /** The type of button, based on this it will decide how the styling will be. */
  type?: "button" | "submit" | "reset";
};

export enum ButtonType {
  Primary = "primary",
  Secondary = "secondary",
  Link = "link",
}
